/**
* @ class State model declaration for store admin User related fields
**/
export interface AdminState {
  UpdateType: string;
  updateAttribute: string;
  updateValue: string;
  updatedDate: string;
  otherParams: object;
}
/**
* @ class Initial State model for admin store
**/
export const initialAdminState: AdminState = {
  UpdateType: '',
  updateAttribute: '',
  updateValue: '',
  updatedDate: '',
  otherParams: {}
};
